const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export function getTrafficSource() {
  return localStorage.getItem('traffic_source') || 'direct';
}

export function initTracking() {
  const params = new URLSearchParams(window.location.search);
  const src = params.get('src') || params.get('utm_source');

  if (src && !localStorage.getItem('traffic_source')) {
    localStorage.setItem('traffic_source', src.toLowerCase().slice(0, 50));
  }

  if (sessionStorage.getItem('visit_tracked')) return;
  sessionStorage.setItem('visit_tracked', 'true');

  fetch(`${BACKEND_URL}/api/track/visit`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      src: src ? src.toLowerCase().slice(0, 50) : getTrafficSource(),
      path: window.location.pathname,
      referrer: document.referrer || ''
    })
  }).catch(() => {});
}
